import styled from '@emotion/styled';

/**
 * Container for the entire Ask NikeAI search result
 * Houses the shimmer button and query display
 * Responsive padding for mobile
 */
export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  cursor: pointer;

  /* Mobile: Add horizontal padding */
  @media (max-width: 959px) {
    padding: 0 24px;
  }

  &:focus-visible {
    outline: 2px solid var(--podium-cds-color-black);
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

/**
 * Query display input (readonly)
 * Shows the user's search query as they type
 * or displays placeholder text
 * Uses readonly input for accessibility
 */
export const StyledQueryDisplay = styled.input`
  flex: 1;
  min-width: 0;
  height: 48px;
  padding: 0 16px;
  border: none;
  background: transparent;
  font-family: 'Helvetica Now Text', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: var(--podium-cds-color-text-primary, #111111);
  cursor: pointer;
  pointer-events: none;

  /* Remove default input styling */
  &:focus {
    outline: none;
  }

  /* Placeholder styling */
  &::placeholder {
    color: var(--podium-cds-color-text-primary, #111111);
    opacity: 1;
  }

  /* Ensure text doesn't wrap */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
